<script lang="ts">
    import MediaImage from '$components/MediaImage/MediaImage.svelte';
    import { createEventDispatcher } from 'svelte';

    export let format = 'w200';
    export let mediaId: number;
    export let canRemove: boolean = true;
    const dispatch = createEventDispatcher<{
        remove: void;
    }>();
</script>

<div
    class={'relative shrink-0 group size-[80px] border border-gray-300 rounded-lg p-1 shadow-md'}
>
    <MediaImage {mediaId} {format} class={'w-full h-full object-cover rounded-lg'} />
    {#if canRemove}
        <button
            type="button"
            on:click|preventDefault={() => dispatch('remove')}
            class={'absolute top-0 right-0 hidden group-hover:inline-flex items-center justify-center w-8 h-8 -mr-4 -mt-4 rounded-full text-white bg-black'}
        >
            <i class="fa fa-times" />
        </button>
    {/if}
</div>
